import { render, staticRenderFns } from "./WorkflowDetailCollapse.vue?vue&type=template&id=1db30526&scoped=true"
import script from "./WorkflowDetailCollapse.vue?vue&type=script&lang=js"
export * from "./WorkflowDetailCollapse.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDetailCollapse.vue?vue&type=style&index=0&id=1db30526&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db30526",
  null
  
)

export default component.exports